import { motion } from 'framer-motion';

/**
 * Loading - A high-end, animated spinner fallback for Suspense.
 */
const Loading = () => {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="relative">
        {/* Animated accent circle */}
        <motion.div
          animate={{
            rotate: 360,
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="w-16 h-16 rounded-full border-4 border-primary/20 border-t-primary shadow-glow"
        />
        
        {/* Secondary branding pulse */}
        <motion.div
           initial={{ opacity: 0.5, scale: 0.5 }}
           animate={{ opacity: 0, scale: 1.5 }}
           transition={{
             duration: 1,
             repeat: Infinity,
             ease: "easeOut"
           }}
           className="absolute inset-0 bg-primary/20 rounded-full"
        />

        {/* Brand indicator */}
        <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-2 h-2 rounded-full bg-primary" />
        </div>
      </div>
    </div>
  );
};

export default Loading;
